import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MPipesModule } from '@mining/ui/pipes';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { MSidebarMenuDetailInfoComponent } from './sidebar-menu-detail-info.component';
import { MSidebarMenuHeaderComponent } from './sidebar-menu-header.component';
import { MSidebarMenuItemComponent } from './sidebar-menu-item.component';
import { MSidebarMenuSearchComponent } from './sidebar-menu-search.component';
import { MSidebarMenuShortcutComponent } from './sidebar-menu-shortcut.component';
import { MSidebarMenuComponent } from './sidebar-menu.component';

const selfComponents = [
  MSidebarMenuComponent,
  MSidebarMenuItemComponent,
  MSidebarMenuHeaderComponent,
  MSidebarMenuDetailInfoComponent,
  MSidebarMenuSearchComponent,
  MSidebarMenuShortcutComponent
];
@NgModule({
  imports: [
    CommonModule,
    NzTabsModule,
    NzIconModule,
    NzToolTipModule,
    FormsModule,
    NzCheckboxModule,
    NzSpinModule,
    NzInputModule,
    NzEmptyModule,
    MPipesModule
  ],
  declarations: [...selfComponents],
  exports: [...selfComponents]
})
export class MSidebarMenuModule {}
